export const CONFIG_PLUGIN = {

    // ------------------------------- 🔥 CONTEXTS
    CONTEXTS: {
        HAS__THEME_CONTEXT: true,
        HAS__NOTIFY_CONTEXT: true,
        HAS__ROUTING_CONTEXT: true,
        HAS__TRANSLATE_CONTEXT: true,
        HAS__USER_AUTH_CONTEXT: true,
        HAS__TRACKING_META_SEO: true,
    },

    // ------------------------------- 🔥 MODULES
    MODULES: {
        HAS__MODULE_TAGS: true,
        HAS__MODULE_ARCHIVE: true,
        HAS__MODULE_PROFILE: true,
        HAS__MODULE_PROJECTS: true,
        HAS__MODULE_PERSONAL_VAULT: true,
        HAS__MODULE_MANUALS: true,
        HAS__MODULE_LIBRARY: true,
        HAS__MODULE_SAVINGS: true,
        HAS__MODULE_MONTHLY_EXPENSES: true,
        HAS__MODULE_COURSES: true,
        HAS__MODULE_DASHBOARD: true,
        HAS__MODULE_COMPANIES: true,
        HAS__MODULE_TOOLS: true,
        HAS__MODULE_COMMANDS: true,
        HAS__MODULE_SNIPPETS: true,
        HAS__MODULE_WISHLIST: true,
        HAS__MODULE_CONTACTS: true,
        HAS__MODULE_NOTEBOOK: true,
        HAS__MODULE_STICKY_NOTES: true,
    },

    // ------------------------------- 🔥 SCREENS AUTH
    SCREENS: {
        HAS__SCREEN_REMEMBER_ME: true,

        SCREEN__PASSWORD_MIN_LENGTH: 6,
    },

    // ------------------------------- 🔥 ROUTING
    ROUTING: {
        HAS__ROUTE_GUARD: true,
        HAS__MAINTENANCE_MODE: false,
        HAS__REDIRECT_WHEN_PAGE_404: false,
    },

    // ------------------------------- 🔥 TEMPLATES
    TEMPLATES: {
        HAS__TEMPLATE_PREVIEW_REMEMBER: true,
        HAS__TEMPLATE_PREVIEW_FOOTER_FIXED: false,
        HAS__SHOW_APP_TOASTER_NOTIFY_TEST: false,
    },

    // ------------------------------- 🔥 SECURITY & ROUTING FLAGS
    SECURITY: {
        HAS__BLOCKED_MODULE_AUTH_WHEN_LOGGED: true, // true: Bloqueamos todos los módulos AUTH. Pero no el resto.
    },

    // ------------------------------- 🔥 SYSTEM & SERVER NOTICES
    NOTICES: {
        HAS__NOTICE_ERROR_NETWORK_OFFLINE: true, // true: Mostramos un aviso si el cliente pierde internet.
        HAS__NOTICE_ERROR_SERVER_DOWN: true, // true: Mostramos un aviso de error si el servidor está caído.
        HAS__NOTICE_ERROR_COMPILER_DOWN: true, // true: Mostramos un aviso de error si el compilador/mantenimiento está caído.

        HAS__NOTICE_COOKIE_CONSENT_BANNER: true, // true: Muestra el banner de aceptación de cookies/privacidad.
        HAS__NOTICE_API_RATE_LIMIT_EXCEEDED: true, // true: Avisa si el usuario superó el límite de peticiones (Error 429).
        HAS__NOTICE_NEW_VERSION_AVAILABLE: true, // true: Avisa al usuario cuando despliegas un cambio nuevo en producción ("Nueva versión disponible").
    },

    // ------------------------------- 🔥 SCROLL BEHAVIOR & UI HELPERS
    SCROLL: {
        // ------------- 🎯 PUBLIC
        HAS__PUBLIC_SCROLL_HOME_DOWN: true,
        HAS__PUBLIC_SCROLL_HOME_TO_TOP: true,
        HAS__PUBLIC_SCROLL_SMOOTH_ENABLE: true,
        HAS__PUBLIC_SCROLL_BLOG_SINGLE_POST_TO_TOP: true,
        HAS__PUBLIC_SCROLL_STICKY_HEADER_HIDE_ON_DOWN: true, // true: Oculta el header al bajar y lo muestra al subir.

        // ------------- 🎯 PRIVATE / DASHBOARD
        HAS__PRIVATE_SCROLL_MODAL_AUTO_RESET: true,
        HAS__PRIVATE_SCROLL_TABLE_RECORD_TO_TOP: true,
        HAS__PRIVATE_SCROLL_PRESERVE_ON_BACK: true, // true: Mantiene la posición del scroll al presionar el botón "Atrás" del navegador.
    },

    // ------------------------------- 🔥 INTERACTIONS
    INTERACTIONS: {
        HAS__AUTO_LOGOUT_ON_IDLE: false, // true: Cierra sesión automáticamente si el usuario está inactivo.
        HAS__CONFIRM_BEFORE_UNSAVED_LEAVE: true, // true: Muestra un aviso si el usuario intenta salir de la página con cambios sin guardar.

        HAS__COPY_TO_CLIPBOARD_TOAST: true, // true: Muestra un "copiado al portapapeles" al hacer clic en tokens, IDs o links.
        HAS__KEYBOARD_SHORTCUTS_ENABLE: true, // true: Habilita atajos de teclado (ej: Ctrl+K para buscar, Esc para cerrar modales).
        HAS__PREVENT_DOUBLE_SUBMIT_FORM: true, // true: Deshabilita botones de submit mientras la petición está procesándose para evitar duplicados.
    },

    // ------------------------------- 🔥 PERFORMANCE & OPTIMIZATION 
    PERFORMANCE: {
        HAS__LAZY_LOADING_IMAGES: true, // true: Carga imágenes diferidas a medida que entran en pantalla.
        HAS__PREFETCH_NEXT_ROUTES: true, // true: Precarga los assets de los enlaces en hover para navegación ultrarrápida.
        HAS__ANALYTICS_TRACKING_EXTERNAL: true, // true: Habilita la recolección de métricas (Google Analytics, Mixpanel, etc.).
        HAS__ANALYTICS_TRACKING_INTERNAL: true, // true: Habilita la recolección de métricas para visualizar en el panel interno del sistema.
    }
};